import { Validator } from '@vista-digital/validator';
/*
 * Default display text for the Seat Picker component.
 */
export const defaultSeatPickerDisplayText = {
    screenNameFormat: '${screenName}',
    errorExceededAllocatedSeatsMessage: 'You cannot exceed your allocated seats for an area category',
    errorGapBetweenSelectedSeatsMessage: 'You cannot leave a gap between seats you have selected',
    errorSingleSeatGapFromAisleMessage: 'You cannot leave a single seat gap from an aisle',
    errorSingleSeatGapFromUnavailableSeatMessage: 'You cannot leave a single seat gap from an unavailable seat',
    errorSelectedUnavailableSeatMessage: 'One or more seats you have chosen are no longer available',
    errorEntireSofaNotSelectedMessage: 'You must select the entire sofa',
    errorNotAllSeatsSelectedMessage: 'You haven’t selected all your seats',
    errorCompanionSeatNotSelectedMessage: 'You must select the associated wheelchair seat for all companion seats',
    errorNoSeatsSelectedMessage: 'You must select at least one seat'
};
export const seatPickerDisplayTextValidatorSchema = {
    screenNameFormat: Validator.optional(Validator.nonEmptyString),
    errorExceededAllocatedSeatsMessage: Validator.nonEmptyString,
    errorGapBetweenSelectedSeatsMessage: Validator.nonEmptyString,
    errorSingleSeatGapFromAisleMessage: Validator.nonEmptyString,
    errorSingleSeatGapFromUnavailableSeatMessage: Validator.nonEmptyString,
    errorSelectedUnavailableSeatMessage: Validator.nonEmptyString,
    errorEntireSofaNotSelectedMessage: Validator.nonEmptyString,
    errorNotAllSeatsSelectedMessage: Validator.nonEmptyString,
    errorCompanionSeatNotSelectedMessage: Validator.nonEmptyString,
    errorNoSeatsSelectedMessage: Validator.nonEmptyString
};
export const seatPickerDisplayTextValidator = Validator.object(seatPickerDisplayTextValidatorSchema);
//# sourceMappingURL=display-text.js.map